import React, { Component } from "react";
import { Box, Button, Main } from "grommet";
import { Actions, Book, Github, Info } from "grommet-icons";

class ProjectsPage extends Component {
  render() {
    return (
      <Main direction="row" flex overflow={{ horizontal: "hidden" }}>
        <Box
          flex
          align="center"
          justify="center"
          direction="column"
          gap="small"
        >
          <Button
            label="IoT Weather Station"
            href={`${process.env.PUBLIC_URL}/IEC_Final_Report.pdf`}
            target="_blank"
            icon={<Actions />}
          />

          <Button
            label="Hyperparameter Tuning"
            href={`${process.env.PUBLIC_URL}/Machine_Learning_Final_Report.pdf`}
            target="_blank"
            icon={<Info />}
          />

          <Button
            label="Class Notes"
            href="https://github.com/rpaulucci3/class-notes/releases"
            target="_blank"
            icon={<Book />}
          />

          <Button
            primary
            label="More on GitHub"
            href="https://github.com/rpaulucci3"
            target="_blank"
            icon={<Github />}
          />
        </Box>
      </Main>
    );
  }
}

export default ProjectsPage;
